export default __webpack_public_path__ + "static/media/envato.b659dfb6.svg";